{
  "title": "التقارير",
  "tabs": {
    "summary": "ملخص الحوالات",
    "detailed": "الحركات التفصيلية",
    "by-branch": "حسب الفرع",
    "by-employee": "حسب الموظف",
    "by-customer": "حسب العميل",
    "holders": "حركة ورصيد الصناديق والحسابات"
  },
  "filters": {
    "branch": "الفرع",
    "employee": "الموظف",
    "box": "الصندوق",
    "bankAccount": "الحساب البنكي",
    "customer": "العميل",
    "direction": "الاتجاه"
  },
  "actions": {
    "exportExcel": "تصدير إلى Excel",
    "exportPdf": "تصدير PDF"
  },
  "summary": {
    "transferCount": "عدد الحوالات",
    "totalAmount": "إجمالي مبالغ الحوالات",
    "totalCommission": "إجمالي العمولات",
    "commissionNote": "دخل خدمي، وليس صافي الربح بعد المصاريف.",
    "totalNet": "إجمالي الصافي",
    "cancelledTitle": "الحوالات الملغاة",
    "cancelledLine": "{{count}} حوالة بمبلغ {{amount}}",
    "cancelledExcludedNote": "مستبعدة من الإجماليات أعلاه."
  },
  "detailed": {
    "title": "الحركات التفصيلية",
    "columns": {
      "number": "رقم الحوالة",
      "direction": "الاتجاه",
      "date": "التاريخ",
      "branch": "الفرع",
      "sender": "المرسل",
      "receiver": "المستلم",
      "amount": "مبلغ الحوالة",
      "commission": "العمولة",
      "net": "الصافي",
      "bankAccount": "الحساب البنكي",
      "box": "الصندوق",
      "employee": "الموظف",
      "state": "الحالة"
    },
    "rowActions": {
      "trigger": "إجراءات الحوالة {{number}}",
      "viewDetails": "عرض التفاصيل"
    },
    "states": {
      "DRAFT": "مبدئية",
      "POSTED": "مسجلة",
      "CANCELLED": "ملغاة"
    }
  },
  "grouped": {
    "columns": {
      "count": "عدد الحوالات",
      "amount": "المبلغ",
      "commission": "العمولة",
      "net": "الصافي",
      "cancelledCount": "الملغاة"
    },
    "totalRow": "الإجمالي"
  },
  "byBranch": {
    "title": "حسب الفرع",
    "columns": {
      "branch": "الفرع"
    }
  },
  "byEmployee": {
    "title": "حسب الموظف",
    "columns": {
      "employee": "الموظف"
    }
  },
  "byCustomer": {
    "title": "حسب العميل",
    "columns": {
      "customer": "العميل",
      "asSender": "كمرسل",
      "asReceiver": "كمستلم"
    }
  },
  "holders": {
    "title": "حركة ورصيد الصناديق والحسابات",
    "kind": {
      "BOX": "صندوق",
      "BANK_ACCOUNT": "حساب بنكي"
    },
    "columns": {
      "holder": "الصندوق / الحساب",
      "opening": "الرصيد الافتتاحي",
      "totalIn": "إجمالي الوارد",
      "inByType": "تفصيل الوارد",
      "totalOut": "إجمالي الصادر",
      "outByType": "تفصيل الصادر",
      "closing": "الرصيد الختامي"
    },
    "sharedAccountNote": "الحساب البنكي المشترك بين عدة فروع يظهر مرة واحدة في هذا التقرير.",
    "notBankReadingNote": "الأرصدة المعروضة هي نتيجة الحركات المسجلة، وليست قراءة من كشف البنك."
  }
}
